<template>
  <div>
  <b-modal
    :title="`直推會員繳款明細表(業務：${data.number} ${data.name})`"
    size="xl"
    centered
    hide-footer
    header-class="head-modal"
    v-model="modalShow"
  >
    <div class="operate">
      <div class="search">
        <b-form-select
          v-model="search.class"
          :options="options.class"
        ></b-form-select>
      </div>

      <div class="btn-area">
        <div class="btn-function">
          <b-button variant="danger" @click="resetSearch()">重置</b-button>

          <b-button variant="success" @click="getMemberUnpaid()">搜尋</b-button>
        </div>
      </div>

    </div>

    <tables-page
      :tableData="table_data"
      :tableFields="table_fields"
    >
      <template #cell(no)="row">
        {{ row.index + 1 }}
      </template>

      <template #cell(period)="row">
        {{ row.item.details.period }}
      </template>

      <template #cell(type)="row">
        {{ getBillFeeDescription(row.item.details) }}
      </template>

      <template #cell(join_date)="row">
        {{ convertRocDate(row.item.join_date, false) }}
      </template>

      <template #cell(amount)="row">
        {{ row.item.details.amount }}
      </template>

      <template #cell(receive)="row">
        {{ getBillReceiveMethodText(row.item.receive) }}
      </template>
    </tables-page>

    <b-overlay :show="status.isLoading" no-wrap></b-overlay>
  </b-modal>
</div>
</template>

<script>
import TablesPage from "@/components/layouts/TablesPage";
import businessInfoApi from "@/models/API/businessInfoApi";
import { convertRocDate, getBillReceiveMethodText, getBillFeeDescription } from "@/models/HELPERS/common.js";

export default {
  name: 'MemberPaymentModal',
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    show: {
      type: Boolean,
      required: false,
      default: false
    },
    data: {
      type: Object,
      required: false,
      default: () => {}
    }
  },
  components: {
    TablesPage
  },
  data () {
    return {
      status: {
        isLoading: false
      },
      options: {
        class: [
          { value: 0, text: '已繳' },
          { value: 1, text: '未繳' },
        ],
      },
      search: {
        class: 1
      },
      table_fields: [
        {
          key: "no",
          label: "序號",
        },
        {
          key: "plan",
          label: "組別",
        },
        {
          key: "number",
          label: "契約編號",
        },
        {
          key: "member_name",
          label: "姓名",
        },
        {
          key: "pay_name",
          label: "繳款者",
        },
        {
          key: "pay_Baddress",
          label: "帳單地址",
        },
        {
          key: "pay_cellphone",
          label: "手機",
        },
        {
          key: "period",
          label: "期別",
        },
        {
          key: "type",
          label: "類別",
        },
        {
          key: "join_date",
          label: "入會日期",
        },
        {
          key: "amount",
          label: "互助金",
        },
        {
          key: "receive",
          label: "帳單領取",
        },
      ],
      table_data: []
    }
  },
  computed: {
    modalShow: {
      get() {
        return this.show;
      },
      set(value) {
        this.$emit('change', value);
      }
    },
  },
  watch: {
    show: {
      handler(newValue, oldValue) {
        if (newValue) this.getMemberUnpaid();
      },
      immediate: false
    }
  },
  mounted() {
    this.businessInfoApi = new businessInfoApi();
    this.load();
  },
  methods: {
    // 首次載入讀取
    load() {

    },
    convertRocDate,
    getBillReceiveMethodText,
    getBillFeeDescription,
    // 查詢直推會員未繳明細表
    getMemberUnpaid() {
      this.status.isLoading = true;

      const params = {
        ...this.search,
        'sales_number': this.data.number,
      }

      this.businessInfoApi.getMemberUnpaid((response) => {
        const res = response.data;

        this.table_data = [];

        res.data.forEach(item => {
          const data = item;

          item.details.forEach(item_details => {
            this.table_data.push({
              ...data,
              details: item_details
            })
          })
        })

        this.status.isLoading = false;
      }, params, false)
    },
    // 重置欄位，並搜尋
    resetSearch() {
      this.search = {
        class: 1
      }

      this.getMemberUnpaid();
    },
  }
}
</script>

<style lang="scss" scoped>
.operate {
  display: flex;
  white-space: nowrap;
  margin-bottom: 20px;
  column-gap: 20px;
  .search {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 10px;
    flex-basis: 80%;
  }
  .btn-area {
    flex-basis: 20%;
    .btn-function {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      gap: 10px;

    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Backstage/businessInfo/components/modal/MemberPaymentModal.vue